import { EntrepreneurAnnounce10InnovationFormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce10InnovationFormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
// import { DetailInnovationCourseComponent } from "../../../components/SupportSystem/SupportForm/DetailInnovationCourseComponent";

export function EntrepreneurAnnounce10FormInnovationContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurAnnounce10InnovationFormComponent/>
            {/* <DetailInnovationCourseComponent /> */}
            <Footer />
        </div>        
    )
    
}